import React from "react";
import {PanelEditProfile} from "../../UI/Profile/Edit/PanelEditProfile";

const ProfilePage = () => {
  return (
    <div>
      <PanelEditProfile />
    </div>
  );
};

export default React.memo(ProfilePage);

